import { useToggle } from "react-use";
import { MoreVertical } from "lucide-react";

import {
  DropdownMenu,
  DropdownMenuContent,
  DropdownMenuItem,
  DropdownMenuTrigger,
} from "@/components/ui/dropdown-menu";
import { Button } from "@/components/ui/button";
import { useDeleteSubcollectionMutation } from "@/modules/snapshots/snapshotCollection.api";
import { Subcollection } from "@/modules/snapshots/snapshotCollection.types";
import { RenameSubcollectionModal } from "@/modules/snapshots/modals/renameSubcollectionModal";

interface Props {
  subcollection: Subcollection;
}

export const SubcollectionKebab = ({ subcollection }: Props) => {
  const [isRenameOpen, toggleRenameOpen] = useToggle(false);
  const [deleteSubcollection] = useDeleteSubcollectionMutation();

  const onDelete = async () => {
    if (
      !window.confirm(`Delete sub-collection "${subcollection.name}"? Snapshots will remain in the parent collection.`)
    ) {
      return;
    }
    await deleteSubcollection({ id: subcollection.id }).unwrap();
  };

  return (
    <>
      <DropdownMenu>
        <DropdownMenuTrigger asChild>
          <Button variant="ghost" size="icon" aria-label="More actions" onClick={e => e.stopPropagation()}>
            <MoreVertical className="h-4 w-4" />
          </Button>
        </DropdownMenuTrigger>
        <DropdownMenuContent>
          <DropdownMenuItem onSelect={() => toggleRenameOpen(true)}>Rename</DropdownMenuItem>
          <DropdownMenuItem onSelect={onDelete} className="text-red-600">
            Delete
          </DropdownMenuItem>
        </DropdownMenuContent>
      </DropdownMenu>
      <RenameSubcollectionModal
        open={isRenameOpen}
        onClose={() => toggleRenameOpen(false)}
        subcollectionId={subcollection.id}
        currentName={subcollection.name}
      />
    </>
  );
};
